const translations = {
    es: {
        logo_description: "Manera conveniente de obtener un préstamo en México.",
        footer_text: " - Conveniente selección de préstamos en México, 2019",
        sign_in_through: "O entrar a través",

        register: "Registrarse",
        enter: "Entrar",
        exit: "Salir",
        next: "Continuar",
        back: "Atrás",
        close: "Cerrar",
        confirm: "Confirmar",
        save: "Guardar",
        complite: "Terminar",
        skip: "Saltar",

        personal_data: "Datos personales",

        step_counter: "{number} fase",

        confirm_email: "Confirmar correo electrónico",
        confirm_phone: "Verificar número de teléfono",

        email_not_confirmed: "Tu Email no ha sido verificado",
        phone_not_confirmed: "Tu teléfono no está verificado",

        change_password: "Cambia la contraseña",
        settings_saved: "Los ajustes se han guardado",
        password_saved: "Contraseña guardada",

        attributes: {
            phone_number: "número de teléfono",
            email: "correo electrónico",
            password: "contraseña",
            confirm_password: "confirmar contraseña",
            surname: "apellido",
            name: "nombre",
            second_name: "segundo nombre",
            birthday: "Fecha de nacimiento",
            address: "La direccion",
            vendorConfirm: "Confirmar el consentimiento para el procesamiento de datos personales",
            vendor_confirm: "Confirmar el consentimiento para el procesamiento de datos personales",
            passport: "Pasaporte",
        },

        pay: {
            subscriptionConfirm:
                "Acepto una suscripción, que cuesta 6,99 USD por cada 7 días de uso del servicio",
            commission: "comisión de servicio 6,99 USD por cada 7 días de uso del servicio",
            account: "Cuenta",
            card_list: "Sus tarjetas bancarias",
            no_card: "No tienes una tarjeta bancaria atada",
            add: "Añadir una nueva tarjeta bancaria",
            active: "Activo",
            success: "Su tarjeta bancaria se ha vinculado con éxito",
            notification_text:
                "Por favor, añada los datos de su tarjeta de pago. Esto es necesario para evaluar su salud financiera y seleccionar ofertas personales.",
            help_text_modal:
                "Use tarjetas VISA o MASTERCARD para una encuadernación exitosa. La tarjeta será cargada con <b>1 unidad monetaria </b> contra el costo del servicio.",

            activation: "Activación de la cuenta",
            help_text:
                "Para activar el servicio, introduzca los datos de su tarjeta. Para una encuadernación exitosa use tarjetas VISA o MASTERCARD. De la tarjeta se descontará <b>1 unidad monetaria </b> en el coste del servicio.",
            why: "¿Por qué necesitas atar un mapa?",
            why_hint:
                "Esto es necesario para evaluar su salud financiera <br> y para seleccionar ofertas personalizadas.",
            more_info: "Más información sobre las suscripciones",
            pass: "Saltar",
            decline:
                "El pago está cancelado. Inténtelo de nuevo o especifique los detalles de otra tarjeta bancaria.",
            info:
                "¡Advertencia! no es una institución de crédito. {host} ofrece un acceso limitado de pago por visión a un software comparable para facilitar la búsqueda de una institución de crédito con licencia. Para obtener el servicio de concordancia de productos de crédito, debe vincular su tarjeta bancaria (VISA, MASTERCARD) a su cuenta. La tarjeta debe tener un saldo que no sea cero. Al realizar un pago, usted acepta la oferta pública de suscripción y da su consentimiento para el tratamiento de los datos personales y la recepción de material promocional.También confirma que ha sido notificado sobre la anulación del pago de autorización contra el costo del servicio de vinculación de la tarjeta, sobre la anulación de 6.99 USD cada 7 días de la utilización del servicio por un período de cinco meses e instruye al operador a aplicar los pagos recurrentes.  La seguridad de los pagos se lleva a cabo con la ayuda de Bank-EQUIRE, que funciona sobre la base de protocolos y tecnologías modernos, desarrollados por los sistemas internacionales de pago VISA International y MasterCard International (3D Secure, USAF). La seguridad de la información transferida está garantizada por medio de los modernos protocolos de seguridad de Internet (SSL/TLS). Traducción realizada con la versión gratuita del traductor www.DeepL.com/Translator",
            offer_payment_text:
                "Para dejar la solicitud en el banco, atar la tarjeta con la que se recibirá el dinero del banco. Para verificar la tarjeta, se escribirá 1 USD.",
            registration_help_text:
                "Hemos comprobado sus datos y preparado una lista de bancos que han aprobado la cantidad requerida para usted. Para ver la lista de bancos, confirme el número de la tarjeta que recibirá el dinero de los bancos en el futuro. Para verificar la tarjeta, se escribirá 1 USD",
        },

        my_offers: "Mis ofertas ",
        profile: "Perfil",
        offers: "Ofertas",
        users: "Usuarios",
        deals: "Repartos",
        notification_settings: "Configuración de las notificaciones",
        user_cabinet: "Gabinete de usuario",
        forgot_password: "¿Olvidaste tu contraseña?",
        divider_or: "o",
        personal_info: "Información personal",

        phone_number: "Número de teléfono:",
        email: "Correo electrónico: ",
        password: "Contraseña:",
        confirm_password: "Confirmar contraseña:",

        errors: {
            check_correct: "Compruebe la exactitud de llenado!",
            phone_number_not_valid: "Número de teléfono no válido",
            wrong_auth_params: "Usuario con dicho número de teléfono y contraseña no encontrados",
            wrong_login_or_password: "Usuario o contraseña incorrecta",
            email_not_valid: "Correo email no válido",
            phone_already_registered: "El usuario con este número de teléfono ya está registrado",
            email_already_registered: "El usuario con este correo email ya está registrado",
            server_error: "Error del Servidor",
            wrong_code: "Código incorrecto",
            user_not_registered: "El usuario no pudo registrarse",
            user_not_found: "Usuario no encontrado",
            cant_register: "¡No pudimos registrarlo!",
            unknown_error: "Error desconocido",
            we_cant_send_email: "¡No podemos enviarle un código de verificación!",
        },

        page_not_found: "Página no encontrada",
        return_to_main_page: "Ir a la página principal",

        password_restoration: "Recuperación de contraseña",
        your_email: "Tu correo email:",
        code_from_mail: "Código de email:",
        code_from_sms: "Código de SMS:",
        restore_password: "Restaurar contraseña",
        send_code: "Enviar código",
        send: "Enviar",
        send_again: "Reenviar",
        verify_later: "Verificar luego",
        phone_number_when_you_register: "Número de teléfono que proporcionó durante el registro:",
        to_proceed_enter_sms_code: "Para continuar el registro, ingrese el código de SMS",
        dont_get_code: "¿No recibiste el código?",
        we_send_sms_with_code: "¡Le hemos enviado un SMS con un código de confirmación!",
        sms_was_send_again: "El código de verificación fue reenviado",
        i_need: "Necesito",
        choose_loan_value: "Elige el monto del préstamo",

        get_percent_to_approve_chance_phone_and_email:
            "Obtener el +{possibility}% a la aprobación de la solicitud, indicando el número de teléfono y correo email",
        get_percent_to_approve_chance_phone:
            "Obtener el +{possibility}% de la aprobación de la solicitud, confirmando el número de teléfono.",
        confirm_your_phone: "Confirme su número de teléfono para la identificación!",
        we_will_send_code_to_phone: "Enviaremos al código <b>{phone}</b> en SMS",
        last_step_left: "El último paso queda para conseguir las mejores ofertas!",
        request_for_getting_money: "SOLICITUD DE DINERO",
        approvement_chance: "La probabilidad de aprobación de la solicitud: {loanPossibility}%",
        we_sent_mail_to_your_email_register:
            "Se envió una carta a su correo electrónico <b>{email}</b> para confirmar el registro. <br>\n" +
            "Siga el enlace en la carta para continuar!",
        we_sent_mail_to_your_email_confirm:
            "Se envió una carta a su correo electrónico <b>{email}</b> para confirmar el registro. <br>\n" +
            "Siga el enlace en la carta para continuar!",
        best_offers_for_you:
            "¡Hemos seleccionado para usted las mejores ofertas de las organizaciones de crédito!",
        we_sent_mail_to_you: "Se ha enviado una carta a su correo electrónico: <br> <b>{email}</b>",
        send_SMS_to_phone: "Enviar sms al teléfono",
        SMS_was_send_to_phone: "Se ha enviado un SMS al número: <br> <b>{phone}</b>",
        for_verification_plese_confirm_email:
            "Para su identificación, confirme su dirección de correo electrónico.\n" +
            "Correo electrónico enviado a:",
        to_email: "Al correo!",
        for_email_verificcation: "+25% para confirmación por correo",

        contact_info: "Información del contacto",
        phone_confirmation: "Verificación telefónica",
        email_confirmation: "Verificación email",
        registration_check: "Verificación de registro",

        sum: "Monto: ",
        rating: "Evaluación: ",
        loan_sum: "Monto del préstamo",
        up_to_x_currency: "hasta {sum}",
        loan_period: "Plazo del préstamo",
        up_to_x_days: "hasta {days} días",
        percentage_rate: "Tasa de interés",
        from_x_percent_in_day: "de {bet}% por día",
        from_x_percent: "de {bet}%",
        get_money: "Recibir dinero",
        success_rate: "Porcentaje de aprobación",
        get_more_offers_verificate_your_email: "Recibe más ofertas confirmando tu email",
        go_to_profile: "Ir al perfil",
        currency: "pesos",
        currency_symbol: "$",
        days: "días",

        name: "Nombre: ",
        surname: "Apellido: ",
        second_name: "Segundo nombre: ",

        confirmed: "Confirmado por",
        not_confirmed: "No confirmado",

        my_applications: "Mis aplicaciónes",
        fill_the_information_and_we_can_remind_you:
            "¡Complete la información del préstamo y le recordaremos de manera oportuna!",
        maturity_date: "Fecha de reembolso",
        payout_date: "Fecha de pago",
        correct_data: "Cambiar datos",
        status: "Estado",

        deals_status: {
            approved: "Aprobado por",
            rejected: "Rechazado",
            pending: "Revisión pendiente",
        },

        months: {
            jan: "Enero",
            feb: "Febrero",
            mar: "Marzo",
            apr: "Abril",
            may: "Mayo",
            jun: "Junio",
            jul: "Julio",
            aug: "Agosto",
            sep: "Septriembre",
            oct: "Octubre",
            nov: "Noviembre",
            dec: "Diciembre",
        },

        days_of_the_week: {
            mon: "Lu",
            tue: "Ma",
            wed: "Mi",
            thu: "Ju",
            fri: "Vi",
            sat: "Sá",
            sun: "Do",
        },
        first_day_of_week: "0", // воскресеньe
        go_to: "repasar",
        new_application_header: "¡Felicitaciones, ha aprobado un préstamo!",
        new_applications_body: 'Complete la información del préstamo en la sección "Mis préstamos"',
        no_applications: "Aún no tienes aplicaciones confirmadas",
        post_application: "Deje una solicitud",

        get_now: "Obtenga dinero en línea al <b>0%</b> sin salir de casa",

        we_recommend_to_use_all_offers:
            "¡Recomendamos que deje las aplicaciones en todos los sitios para recibir el 100% del recibo de dinero!",
        mask: {
            phone: "+52 (##) ####-####",
            passport: "XXXXXXXXXXXXXXXXXX",
        },
        loan_possibility_hint: "+ {percent}% de la probabilidad de aprobación de la solicitud",
        mobile_phone: "Número de teléfono móvil",
        address: "Ciudad de nacimiento",
        address_description: "Dirección de registro (totalmente)",
        password_confirm: "Contraseña nuevamente",
        password_description: "Ingrese su contraseña",
        continue: "Continuar",
        done: "hecho",
        vendor_confirm: "Doy mi consentimiento para el",
        private_data: "procesamiento de datos personales",
        advert_agree: "y para recibir material publicitario, así como",
        public_offer: "acepto la oferta pública y los documentos",

        possibility_hint: "<b>+ {percent}%</b> para aprobación para completar el campo {field}",
        possibility_hint_vars: {
            surname: "Apellido",
            name: "Nombre",
            second_name: "Segundo nombre",
            phone: "Numeros telefonicos",
            email: "Email",
            birthday: "Fecha de nacimiento",
            address: "Ciudad de nacimiento",
            passport: "Pasaporte",
        },
        check_requisites: {
            data_analize: "Análisis de entrada de datos",
            checking_information:
                "Nuestros algoritmos procesan la información que ingresa. No lleva mucho tiempo. Por favor no cierre la página...",
            data_check: "Datos verificados: <b>{count}</b>",
            data_check_without_count: "datos verificados",
            step_1: "Paso 1 de 4...",
            step_2: "Paso 2 de 4...",
            step_3: "Paso 3 de 4...",
            step_4: "Paso 4 de 4...",
            check_fio: "Comprobamos el nombre",
            check_date_of_birth: "Comprobando la fecha de nacimiento",
            check_email: "Comprobar correo electrónico",
            check_phone: "Revisando el teléfono",
            check_social: "Análisis de perfiles en redes sociales",
            check_messengers: "Análisis de cuentas en mensajería instantánea",
            find_personal_offers: "Seleccionamos ofertas personales",
            check_ended: "Gracias por esperar, la verificación de sus datos ha terminado",
            check_done: "¡La verificación de datos fue exitosa!",
            data_ckecking: "Validación de datos...",
            complete_percents: "Terminado {percent}%",
        },
        exception: {
            VerificationCodeAlreadySentException:
                "Ya se le ha enviado un código de verificación en {type}",
            UserNotFoundException: "Usuario con dicho número de teléfono no encontrado",
            UserAlreadyRegisteredException:
                "Un usuario con este número de teléfono o correo electrónico ya está registrado",
        },

        credit_score: {
            score: "Calificación crediticia",
            best_offers: "Las mejores ofertas con su calificación crediticia",
            own_model: "La calificación se calcula por el modelo propio del servicio",
            find_out_rating: "Aprenda la calificación crediticia",
            know_you_rating_for_offers:
                "Para obtener las ofertas más <b> rentables </b> averiguar la calificación crediticia.",
            change_answers: "Cambiar las respuestas",
            get_rating: "Obtener calificación crediticia",
            answer_questions: "Responder 5 preguntas",
            calculate_score:
                "Calcularemos su calificación crediticia y prepararemos recomendaciones personales",
            your_score: "Su calificación crediticia: {score}",
            info:
                "Puntuación de crédito personal - una herramienta para evaluar la fiabilidad de un prestatario por parte de una organización de crédito al tomar una decisión sobre la concesión de un préstamo.",
            header: "Clasificación de crédito",
            score_status_hint: "¿Qué significa eso?",
            points: "resultados",
            questions: {
                q1: {
                    header: "¿Ya has pedido un préstamo?",
                    a1: "No había créditos",
                    a2: "Hay activos, aún no extinguidos",
                    a3: "Se han devuelto hasta 5 créditos",
                    a4: "Se han devuelto hasta 10 créditos",
                    a5: "Más de 10 créditos han sido reembolsados",
                },
                q2: {
                    header: "¿Cuál es su tipo de empleo?",
                    a1: "Cabecera",
                    a2: "Un empleado (con un contrato de trabajo)",
                    a3: "Militar/Oficial de la Comisión",
                    a4: "Empresario individual",
                    a5: "Pensionista",
                    a6: "Desempleado",
                },
                q3: {
                    header: "Especifique su experiencia en su trabajo actual.",
                    a1: "Menos de tres meses",
                    a2: "De tres a seis meses",
                    a3: "Menos de un año",
                    a4: "De 1 a 3 años",
                    a5: "Más de tres años",
                },
                q4: {
                    header: "Especifique su edad.",
                    a1: "18-21 años",
                    a2: "22-25 años",
                    a3: "26-29 años",
                    a4: "30-35 años",
                    a5: "36-55 años",
                    a6: "56-60 años",
                    a7: "más de 60 años",
                },
                q5: {
                    header: "Especifique sus ingresos mensuales estimados",
                    a1: "menos de 300 USD",
                    a2: "500 USD",
                    a3: "700 USD",
                    a4: "1000 USD",
                    a5: "2000 USD",
                    a6: "más de 3000 USD",
                },
            },
            status: {
                very_high:
                    "<b>951 - 999</b>: Tienes una muy buena calificación crediticia. Hay muy pocas posibilidades de una denegación de crédito.",
                high:
                    "<b>896 - 950</b>: Tienes una buena calificación crediticia. Tienes una buena oportunidad de conseguir un crédito.",
                normal:
                    "<b>766 - 895</b>: Tienes una calificación crediticia promedio. Recibir un crédito es posible, pero no está garantizado. Para el 100% del préstamo, le recomendamos que deje las solicitudes en todas las ofertas.",
                low:
                    "<b>596 - 765</b>: Tienes una baja calificación crediticia. Hay una baja probabilidad de obtener un crédito. Para aumentar la probabilidad de aprobación del préstamo, recomendamos encarecidamente dejar las solicitudes en todos los sitios web.",
                very_low:
                    "<b>1 - 595</b>: Tienes una calificación crediticia muy baja. Va a ser difícil conseguir un préstamo. Para mejorar su calificación crediticia y la probabilidad de aprobación del préstamo, deje las solicitudes en todos los sitios web.",
            },
        },
        terms_of_use_title: "Información Legal",
        personal_terms_title: "Política de privacidad y de procesamiento de datos",
        terms_of_use:
            "www.mxcredito.net (el “sitio web”) es el la página web mediante la cual las personas físicas residentes pueden " +
            "solicitar préstamos ofrecidos por diversos proveedores de crédito que contratan créditos para personas físicas.\n" +
            "Para ponerse en contacto con MXCREDITO, envíe su correo electronico a: MXCREDITO@mail.ru\n" +
            "La página web está dirigida exclusivamente a adultos residentes.\n" +
            "La información disponible a través de la página web no pretende constituir asesoramiento especifico financiero. Mediante su página web " +
            "MXCREDITO no actúa como asesor financiero a ninguna parte. Los datos y la información proporcionada y presentada en la página web " +
            "(la “información”) se basa en los datos que MXCREDITO ha recibido de terceros (en particular, de los proveedores de créditos/prestamos con " +
            "los que MXCREDITO está cooperando). Tal como MXCREDITO hace todos los esfuerzos de mantener la información actualizada intentando ponerse " +
            "en contacto regular con terceros en caso de detectar cualquier falta de datos en la información que atraiga la atención de MXCREDITO, " +
            "MXCREDITO no puede garantizar exactitud o integridad de la información proporcionada. MXCREDITO no controla (ni tiene la posibilidad de " +
            "hacerlo) sistemáticamente ni revisa la información; es posible que la información sea incompleta, inexacta o desactualizada.\n" +
            "La página web puede contener enlaces a otros sitios web. MXCREDITO no ejerce control sobre los sitios operados y su contenido, no dispone " +
            "de cualquier representación relativa a su contenido, tampoco asume cualquier responsabilidad por ellos o por cualquier pérdida o daño que " +
            "pueda surgir al acceder o usarlos.\n" +
            "MXCREDITO puede en cualquier momento cambiar el contenido del sitio web o las condiciones bajo las cuales está disponible. MXCREDITO " +
            "puede igualmente, en cualquier momento, bloquear el sitio web para que no esté disponible a todos los usuarios o a ciertos grupos " +
            "de los usuarios (por ejemplo, usuarios ubicados en ciertas jurisdicciones).\n" +
            "No se otorgará ninguna licencia u otra autorización de usar cualquier trabajo protegido por derechos de autor, marca registrada o " +
            "datos disponibles en la página web a cualquier tercero o parte que acceda al sitio web. Sin embargo, cualquier sujeto físico, " +
            "residente de España podrá acceder el sitio web, mediante el interface de usuario disponible al público para solicitar que MXCREDITO " +
            "le proporcione toda la información sobre la empresa o sus proveedores activos en el mercado de préstamos español con los cuales MXCREDITO " +
            "coopera facilitándole también todos los datos de tal proveedor de préstamo que le ha ya concedido el préstamo.",
        offer_terms:
            "www.mxcredito.net (el “sitio web”) es el la página web mediante la cual las personas físicas residentes pueden solicitar " +
            "préstamos ofrecidos por diversos proveedores de crédito que contratan créditos para personas físicas.\n" +
            "Para ponerse en contacto con MXCREDITO, envíe su correo electronico a: mcreditone@mail.ru\n" +
            "La página web está dirigida exclusivamente a adultos residentes.\n" +
            "La información disponible a través de la página web no pretende constituir asesoramiento especifico financiero. Mediante su página web " +
            "MXCREDITO no actúa como asesor financiero a ninguna parte. Los datos y la información proporcionada y presentada en la página web " +
            "(la “información”) se basa en los datos que MCREDITOS ha recibido de terceros (en particular, de los proveedores de créditos/prestamos con " +
            "los que MXCREDITO está cooperando). Tal como MXCREDITO hace todos los esfuerzos de mantener la información actualizada intentando ponerse " +
            "en contacto regular con terceros en caso de detectar cualquier falta de datos en la información que atraiga la atención de MXCREDITO, " +
            "MXCREDITO no puede garantizar exactitud o integridad de la información proporcionada. MXCREDITO no controla (ni tiene la posibilidad de hacerlo) " +
            "sistemáticamente ni revisa la información; es posible que la información sea incompleta, inexacta o desactualizada.\n" +
            "La página web puede contener enlaces a otros sitios web. MXCREDITO no ejerce control sobre los sitios operados y su contenido, no dispone de " +
            "cualquier representación relativa a su contenido, tampoco asume cualquier responsabilidad por ellos o por cualquier pérdida o daño que pueda " +
            "surgir al acceder o usarlos.\n" +
            "MXCREDITO puede en cualquier momento cambiar el contenido del sitio web o las condiciones bajo las cuales está disponible. MXCREDITO puede " +
            "igualmente, en cualquier momento, bloquear el sitio web para que no esté disponible a todos los usuarios o a ciertos grupos de los usuarios " +
            "(por ejemplo, usuarios ubicados en ciertas jurisdicciones).\n" +
            "No se otorgará ninguna licencia u otra autorización de usar cualquier trabajo protegido por derechos de autor, marca registrada o datos " +
            "disponibles en la página web a cualquier tercero o parte que acceda al sitio web. Sin embargo, cualquier sujeto físico, residente podrá " +
            "acceder el sitio web, mediante el interface de usuario disponible al público para solicitar que MXCREDITO le proporcione toda la información " +
            "sobre la empresa o sus proveedores activos en el mercado de préstamos español con los cuales MXCREDITO coopera facilitándole también todos los " +
            "datos de tal proveedor de préstamo que le ha ya concedido el préstamo.",
        click_here_if_already_registered: "Haga clic aquí si ya está registrado",
    },
};
export default translations;
